import { render, staticRenderFns } from "./comp_ProductCard.vue?vue&type=template&id=1c72807f&scoped=true&"
import script from "./comp_ProductCard.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard.vue?vue&type=style&index=0&id=1c72807f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c72807f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VSpacer})
